export const HOME = { emergentLink: "emergent-link" };

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  services: "nav-services",
  book: "nav-book",
  myBookings: "nav-my-bookings",
  admin: "nav-admin",
  login: "nav-login",
  logout: "nav-logout",
  userMenu: "nav-user-menu",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  phoneInput: "auth-phone-input",
  submitBtn: "auth-submit-btn",
  googleBtn: "auth-google-btn",
  switchMode: "auth-switch-mode",
  errorMsg: "auth-error-msg",
};

export const BOOKING = {
  card: (type) => `booking-card-${type}`,
  serviceTabs: "booking-service-tabs",
  serviceTab: (type) => `booking-tab-${type}`,
  dateBtn: "booking-date-btn",
  timeSelect: "booking-time-select",
  timeOption: (t) => `booking-time-${t}`,
  addressInput: "booking-address-input",
  phoneInput: "booking-phone-input",
  descInput: "booking-desc-input",
  repairTypeSelect: "booking-repair-type",
  submitBtn: "booking-submit-btn",
  banner60: "booking-banner-60",
  successMsg: "booking-success",
};

export const MYBOOK = {
  list: "my-bookings-list",
  item: (id) => `my-booking-${id}`,
  statusBadge: (id) => `my-booking-status-${id}`,
  cancelBtn: (id) => `my-booking-cancel-${id}`,
};

export const ADMIN = {
  tabPending: "admin-tab-pending",
  tabAll: "admin-tab-all",
  row: (id) => `admin-row-${id}`,
  approveBtn: (id) => `admin-approve-${id}`,
  rejectBtn: (id) => `admin-reject-${id}`,
  completeBtn: (id) => `admin-complete-${id}`,
  statsTotal: "admin-stats-total",
  statsPending: "admin-stats-pending",
};
